"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOTXUnfiToken = exports.IOTXUpToken = exports.IOTXWrappedToken = exports.IOTXNativeToken = void 0;
const utils_1 = require("@unifiprotocol/utils");
exports.IOTXNativeToken = new utils_1.Currency("IOTX", 18, "IOTX", "IoTeX");
exports.IOTXWrappedToken = new utils_1.Currency("0xa00744882684c3e4747faefd68d283ea44099d03", 18, "WIOTX", "WIOTX");
exports.IOTXUpToken = new utils_1.Currency("0x9178f4Ec8a7fF6Fe08E848Eeac3Ddbe1a5fAc70d", 18, "UP", "UP");
exports.IOTXUnfiToken = new utils_1.Currency("0xD2ECEDa377DAe9dAF952c18786be736bEC9312cC", 18, "UNFI", "UNFI");
